// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_ql-8";
export var editMode = "_ql-3";
export var headerRow = "_ql-a";
export var headerTitle = "_ql-b";
export var product = "_ql-1";
export var productDetails = "_ql-5";
export var productDivider = "_ql-7";
export var productImage = "_ql-2";
export var productInfo = "_ql-4";
export var productTitle = "_ql-6";
export var strikethrough = "_ql-9";
export var upsellProductsCard = "_ql-0";